import _slicedToArray from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import sift, { createEqualsOperation } from 'sift';
var theMostFrequent = function theMostFrequent(obj) {
  var all = Object.values(obj).reduce(function (acc, value) {
    var tmp = Array.isArray(value) ? value : [value];
    tmp.forEach(function (value) {
      acc.set(value, (acc.get(value) || 0) + 1);
    });
    return acc;
  }, new Map());
  if (all.size === 0) {
    return undefined;
  }
  var entries = [];
  all.forEach(function (value, key) {
    entries.push([value, key]);
  });
  entries.sort(function (_ref, _ref2) {
    var _ref3 = _slicedToArray(_ref, 1),
      valueA = _ref3[0];
    var _ref4 = _slicedToArray(_ref2, 1),
      valueB = _ref4[0];
    return valueB - valueA;
  });
  return entries[0][1];
};
export function createDependencyValidator(dependencies) {
  if (dependencies) {
    return sift(jsonParse(dependencies), {
      operations: {
        $theMostFrequent: function $theMostFrequent(params, ownerQuery, options) {
          return createEqualsOperation(function (value) {
            return params === theMostFrequent(value);
          }, ownerQuery, options);
        }
      }
    });
  }
  return undefined;
}
function jsonParse(str) {
  try {
    return JSON.parse(str);
  } catch (e) {
    return '';
  }
}